import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'

import style from './popover.sass'

@inject('store') @observer
class Popover extends Component {
  state = {
    activeIndex: 0
  }
  componentDidMount() {
    this.setState({activeIndex: 0})
    document.addEventListener('keydown', this.keydownHandler)
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.keydownHandler)
  }
  keydownHandler = (e) => {
    switch(e.key) {
    case 'ArrowUp':
      e.preventDefault()
      this.onArrowUp()
      break
    case 'ArrowDown':
      e.preventDefault()
      this.onArrowDown()
      break
    case 'Tab':
    case 'Enter':
      e.preventDefault()
      this.commitSelection()
      break
    case 'Escape':
      e.preventDefault()
      this.close()
      break
    }
  }
  onArrowUp = () => {
    const {activeIndex} = this.state
    if (typeof activeIndex !== 'number') {
      return
    }
    if (activeIndex > 0) {
      this.setState({
        activeIndex: activeIndex - 1
      })
      const listRect = this.list.getBoundingClientRect()
      const activeItemRect = this.list.querySelector('.selected').getBoundingClientRect()
      if (activeItemRect.top < listRect.top) {
        this.list.scrollTop += activeItemRect.top - listRect.top
      }
    }
  }
  onArrowDown = () => {
    const {activeIndex} = this.state
    const {array} = this.props.popoverState
    if (typeof activeIndex !== 'number') {
      return
    }
    if (activeIndex < array.length - 1) {
      this.setState({
        activeIndex: activeIndex + 1
      })
      const listRect = this.list.getBoundingClientRect()
      const activeItemRect = this.list.querySelector('.selected').getBoundingClientRect()
      if (activeItemRect.bottom > listRect.bottom) {
        this.list.scrollTop += activeItemRect.bottom - listRect.bottom
      }
    }
  }
  commitSelection = () => {
    const value = this.props.popoverState.array[this.state.activeIndex]
    this.props.commitSelection()
    this.props.store.signal.setValues({value})
    this.props.showModal()
  }
  clickHandler = (e) => {
    const activeIndex = +e.target.getAttribute('data-index')
    this.setState({activeIndex: activeIndex})
    this.commitSelection()
  }
  setActive = (e) => {
    const activeIndex = +e.target.getAttribute('data-index')
    if (typeof activeIndex === 'number') {
      this.setState({activeIndex})
    }
  }
  render() {
    const {popoverState, editorFocused} = this.props
    const {top, left, array} = popoverState
    if (!array || !array.length || !editorFocused) {
      return null
    }

    return(
      <ul styleName='popover' style={{top: top - window.pageYOffset, left: left - window.pageXOffset}} ref={el => this.list = el}>
        {array.map((suggestion, index) =>(
          <li
            key={suggestion}
            onMouseEnter={this.setActive}
            onClick={this.clickHandler}
            className={this.state.activeIndex === index ? 'selected' : ''}
            data-index={index}
            tabIndex={-1}
          >
            {suggestion}
          </li>
        ))}
      </ul>
    )
  }
}

export default Popover
